<template>
  <div :id="blok.id" v-editable="blok" class="marketing-product-aid-blok">
    <AppProductAid
      :intro-title="blok.intro_title ?? ''"
      :like-icon="blok.intro_instruction_like_icon?.filename ?? ''"
      :intro-instruction-like="renderRichText(blok.intro_instruction_like) ?? ''"
      :dislike-icon="blok.intro_instruction_dislike_icon?.filename ?? ''"
      :intro-instruction-dislike="renderRichText(blok.intro_instruction_dislike) ?? ''"
      :items
      :products
      :intro-image="blok.intro_image?.filename ?? ''"
      :to-start-title="blok.to_start_title ?? ''"
      :to-start-intro="blok.to_start_intro ?? ''"
      :regional-intro="blok.regional_intro ?? ''"
      :tags
    />
  </div>
</template>

<script setup lang="ts">
  const { blok } = defineProps<{
    blok: MarketingProductAidBlokStoryblok;
  }>();

  // Transform Storyblok items to component format
  const items = computed(() =>
    blok.items.map((item) => ({
      id: item._uid,
      image: item.image?.filename ?? '',
      alt: item.image?.alt ?? '',
      products: item.product?.filter((p) => p !== '') ?? [],
    })),
  );

  // Transform Storyblok tags to component format
  const tags = computed(() =>
    (blok.tags ?? []).map((tag) => ({
      id: tag._uid,
      text: tag.text ?? '',
      products: tag.product?.filter((p) => p !== '') ?? [],
    })),
  );

  // Transform Storyblok products to component format
  const products = computed(() =>
    blok.products.map((product) => ({
      code: product.code,
      image: product.image?.filename ?? '',
      title: product.title ?? '',
      intro: product.intro ?? '',
      link: product.link ?? '',
      isRegional: product.is_regional ?? false,
    })),
  );
</script>

<style lang="postcss" scoped>
  .marketing-product-aid-blok {
    /* scroll-margin-top comes from AppTopicsHeader, which tracks the header's height. */
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }
</style>
